// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingOfferResponse

import { hydrateBookingOfferPrice, type BookingOfferPrice, type BookingOfferPriceApiResponse } from './bookingOfferPrice.gen';

export type BookingOfferApiResponse = {
	offerId: string;
	name: string;
	prices: BookingOfferPriceApiResponse[];
};

export type BookingOffer = {
	offerId: string;
	name: string;
	prices: BookingOfferPrice[];
};

export function hydrateBookingOffer(data: BookingOfferApiResponse): BookingOffer {
	return {
		...data,
		prices: data.prices.map(hydrateBookingOfferPrice),
	};
}